export default {"src":"/_next/static/media/instant.769abe32.svg","height":798,"width":600,"blurWidth":0,"blurHeight":0};